import { StatusPillStyles } from "./statusPill.styles";
import {
  STATUS_THEME,
  ERP_TO_DESIGN_KEY
} from "../../../constants/statusTheme";

// Maps ERP status enum → user-facing label, mirroring the chip filters on
// Services and Employee Schedule (e.g. "accepted" → "Pending"). Unknown
// statuses fall back to the raw enum string so we don't hide anything new.
const resolveStatusLabel = status => {
  const designKey = ERP_TO_DESIGN_KEY[status];
  return STATUS_THEME[designKey]?.label ?? status;
};

const StatusPill = ({ style, status, className }) => {
  return (
    <StatusPillStyles
      style={{ ...style }}
      $status={status}
      className={className}
    >
      {resolveStatusLabel(status)}
    </StatusPillStyles>
  );
};

export default StatusPill;
